const configVariables = {
    termsAndConditionsUrl: 'https://smile-academy.com.au/smile-academy-terms-and-conditions/',
    myLabUrl: process.env.REACT_APP_MYLAB_URL,
    // if isBackend is false, data will be mocked on the frontend. If true, if will use this config file to fetch data
    isBackend: process.env.REACT_APP_BACKEND === 'true',
    apiName: 'admin-portal-api',
    region: 'ap-southeast-2',
    Auth: {
        email: 'admin@smile-academy.com.au', // used for local sign in only
        password: 'password',
    },
    cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    },
    apiEndpoint: process.env.REACT_APP_API_GATEWAY_URL,
};

export default configVariables;
